interface Params {
  headers: Headers
  defaultFilename?: string
}
export const getFilename = ({
  headers,
  defaultFilename = 'file.csv',
}: Params): string => {
  const contentDisposition = headers.get('content-disposition')
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="(.+?)"/)
    if (match && match[1]) {
      return match[1]
    }
  }
  return defaultFilename
}
